import { render } from "./AssignedTo.vue?vue&type=template&id=26b82345"
import script from "./AssignedTo.vue?vue&type=script&lang=js"
export * from "./AssignedTo.vue?vue&type=script&lang=js"

import "./AssignedTo.vue?vue&type=style&index=0&id=26b82345&lang=scss"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__